import React from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../Theme'

const BannerSkeletonContainer = styled.div`
   position: relative;
   background: #e9e9e9;

   .width-1 {
      width: 200px;
   }

   .width-2 {
      width: 150px;
   }

   .width-3 {
      width: 100px;
   }

   .width-4 {
      width: 50%;
   }

   .width-5 {
      width: 100%;
   }

   .height-1 {
      height: 70px;
   }

   .img-placeholder {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      height: 100%;
      width: 100%;
      object-fit: cover;
      background: #545454;
   }

   .page-hero-second-desktop {
      position: relative;
      border-radius: 2rem 0 0 0;
      overflow: hidden;
      ${theme.below.xl} {
         border-radius: 0;
      }
   }

   .page-hero-title {
      display: block;
      font-size: 2.6rem;
      ${theme.below.sm} {
         font-size: 1.6rem;
      }
   }

   .page-hero-mobile-description {
      width: 100%;
      ${theme.below.xl} {
         padding-left: 4rem;
         padding-right: 4rem;
         padding-bottom: 2rem;
      }
      ${theme.below.md} {
         padding-right: 1.5rem;
         padding-left: 1.5rem;
         padding-bottom: 1rem;
      }
   }
`

const BreadCrumbsContainer = styled.div`
   ${theme.below.xl} {
      padding: 2rem 0rem 1rem 4rem;
   }

   ${theme.below.md} {
      padding: 3rem 0rem 0.5rem 1.5rem;
   }
`

const BannerSkeleton = () => {
   return (
      <BannerSkeletonContainer>
         {/* Desktop View */}
         <div className="d-none d-xl-block">
            <div className="row p-0 m-0">
               <div className="page-hero-first col-12 col-xl-6 pt-32 pb-64 pr-32 pl-128 flex-column justify-content-between d-flex">
                  <div className="d-flex flex-column">
                     <ul className="breadcrumb">
                        <li>
                           <a className="link--black link--vb" href="/#">
                              <div className="placeholder placeholder-wave width-1"></div>
                           </a>
                        </li>
                     </ul>
                     <h2 className="page-hero-title">
                        <span className="placeholder placeholder-wave width-4"></span>
                     </h2>
                  </div>
                  <div className="d-flex flex-column">
                     <p className="placeholder placeholder-wave width-5 py-32"></p>
                  </div>
               </div>
               <div className="page-hero-second-desktop col-12 col-xl-6 p-0">
                  <div className="page-hero-image-desktop">
                     <div className="placeholder placeholder-wave img-placeholder" />
                  </div>
               </div>
            </div>
         </div>

         {/* Mobile View */}
         <div className="d-xl-none">
            <div className="row p-0 m-0">
               <div className="col-12 p-0">
                  <div className="page-hero-image-mobile">
                     <BreadCrumbsContainer>
                        <div className="breadcrumb position-relative z-2 m-0">
                           <div className="placeholder placeholder-wave width-1"></div>
                        </div>
                     </BreadCrumbsContainer>

                     <div className="d-flex position-relative justify-content-between align-items-center z-2 px-128 py-8">
                        <h1 className="page-hero-title">
                           <div className="placeholder placeholder-wave width-2"></div>
                        </h1>
                     </div>

                     <div className="page-hero-mobile-description d-flex flex-column gap-3 position-relative z-2">
                        <div className="placeholder placeholder-wave height-1"></div>
                     </div>

                     <div className="placeholder placeholder-wave img-placeholder" />
                  </div>
               </div>
            </div>
         </div>
      </BannerSkeletonContainer>
   )
}

export default BannerSkeleton
